import React from "react";
import styles from "./Mask.module.scss";
import clsx from "clsx";
// import { PageType, useCommonStore } from "@/stores";

interface MaskProps {
  className?: string;
  url?: string;
}
export default function Mask(props: MaskProps) {
  const { className, url } = props;
  const [loaded, setLoaded] = React.useState(false);
  return (
    <div className={clsx(styles.mask_bg, className)}>
      <img
        src={url}
        alt=""
        onLoad={() => {
          setLoaded(true);
        }}
      />
      <div
        className={styles.mask}
        style={
          loaded
            ? {
                backdropFilter: "blur(31)px",
                WebkitBackdropFilter: "blur(31)px",
              }
            : {}
        }
      ></div>
    </div>
  );
}
